// extracted by mini-css-extract-plugin
module.exports = {"schema":"SchemaSidebar_schema__HZ9RS","table":"SchemaSidebar_table__13TE5","column":"SchemaSidebar_column__126R4","schemaSpinner":"SchemaSidebar_schemaSpinner__An3e8"};